import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {greyishBlue600} from "assets/jss/main";

import {formatDate, formatMoney} from "views/personalShopper/components/formatters";

import SideCard from "./SideCard";

PurchasesCard.propTypes = {
    purchases: PropTypes.arrayOf(PropTypes.object).isRequired,
};

/**
 * Orders placed on the site after a click on a card, within 14 days: the assisted purchases.
 */
function PurchasesCard({purchases}) {
    return (
        <SideCard titleId="personalShopper.purchases.title">
            {purchases.length === 0 && (
                <div style={{color: greyishBlue600, fontSize: "13px"}}><FormattedMessage id="personalShopper.purchases.empty" /></div>
            )}
            {purchases.map((purchase) => (
                <div key={purchase.orderNumber} style={{display: "flex", justifyContent: "space-between", padding: "6px 0", fontSize: "13px", borderTop: "1px solid #E6E7EB"}}>
                    <div>
                        <div style={{fontWeight: 600}}>{purchase.orderNumber}</div>
                        <div style={{color: greyishBlue600, fontSize: "12px"}}>
                            {formatDate(purchase.completedAt)} · <FormattedMessage id="personalShopper.purchases.items" values={{count: purchase.itemsCount}} />
                        </div>
                    </div>
                    <div style={{fontWeight: 600}}>{formatMoney(purchase.total, purchase.currencyCode)}</div>
                </div>
            ))}
            {purchases.length > 0 && (
                <div style={{color: greyishBlue600, fontSize: "12px", marginTop: "6px"}}><FormattedMessage id="personalShopper.purchases.hint" /></div>
            )}
        </SideCard>
    );
}

export default PurchasesCard;
